import * as PIXI from 'pixi.js';

import project from './project';
import { getProduct } from '../../services/products';

export default function (
  container,
  size,
  { leftId, rightId, topId, bottomId },
  ratio,
  propping = {}
) {
  const innerId = leftId || bottomId;
  const outerId = rightId || topId;

  const proppingBounds = propping.singleProppingBounds
    ? propping.singleProppingBounds.size
    : null;
  const combined = container || new PIXI.Container();
  const innerProduct = getProduct(innerId);
  const outerProduct = getProduct(outerId);

  /*P in sizes indicate that the sizes are the projected sizes thus considering the rotation of the bounds */
  const innerPSize = project.outer(innerProduct);
  const outerPSize = project.outer(proppingBounds || outerProduct);

  const textures = {
    inner: PIXI.Loader.shared.resources[innerId].texture,
    outer:
      PIXI.Loader.shared.resources[propping.proppingName || outerId].texture,
  };

  const innerSprite = combined.innerSprite || new PIXI.Sprite();
  innerSprite.texture = textures.inner;
  innerSprite.width = innerPSize.width * ratio;
  innerSprite.height = innerPSize.height * ratio;
  combined.innerSprite = innerSprite;

  const outerSprite = combined.outerSprite || new PIXI.Sprite();
  outerSprite.texture = textures.outer;
  outerSprite.width = outerPSize.width * ratio;
  outerSprite.height = outerPSize.height * ratio;
  combined.outerSprite = outerSprite;

  if (leftId && rightId) {
    //horizontal adj
    outerSprite.x = (size.width - outerPSize.width) * ratio;
  } else if (topId && bottomId) {
    //vertical adj
    innerSprite.x = ((outerPSize.width - innerPSize.width) * ratio) / 2;
    innerSprite.y = (size.height - innerPSize.height) * ratio;
  }

  !innerSprite.parent && combined.addChild(innerSprite);
  !outerSprite.parent && combined.addChild(outerSprite);

  return combined;
}
